<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input class="cinput" clearable :placeholder="$t('menu.Bykeywords')" v-model="formInline.title"></el-input>
        
        </el-form-item>
         <el-form-item>
             <el-select v-model="value" clearable  placeholder="请选择">
                <el-option
                  v-for="item in list"
                  :key="item.id"
                  :label="item.seriesModel"
                  :value="item.id">
                </el-option>
              </el-select>
         
        </el-form-item>
   
        <el-form-item>
         <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
        
        </el-form-item>
     
        
      </el-form>
      <div>
        <el-button type="primary" @click="xxaa()">添加到本地配件</el-button>
      </div>
     


    </div>

 <el-table  empty-text=" " :data="mation"  @selection-change="handleSelectionChange" tooltip-effect="dark" style="width: 100%" stripe border highlight-current-row>
  <el-table-column
      type="selection"
      width="60">
    </el-table-column>
   <el-table-column prop="partTypeId" label="配件id" > </el-table-column>
      <el-table-column prop="partNumber" label="配件编号"></el-table-column>
      <el-table-column prop="partName" label="配件名称" > </el-table-column>
      <el-table-column prop="partCategory" label="分类"> 
         <template slot-scope="scope">
         {{ scope.row.partCategory.categoryName }}
        </template>
      </el-table-column>
      <el-table-column prop="mcSeriesModel" label="所属车型"> 
         <template slot-scope="scope">
          <div v-if="scope.row.mcSeriesModel!==null">
             {{ scope.row.mcSeriesModel.seriesModel }}
          </div>
          <div v-else>
            -
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="purchasePriceCny" label="币种"> 
         <template slot-scope="scope">
         {{ shbz }}
        </template>
      </el-table-column>
      <el-table-column prop="purchasePriceCny" label="采购价"> 
         <template slot-scope="scope">
          <div v-if="shbz=='CNY'">
             {{ scope.row.purchasePriceCny }}
          </div>
          <div v-if="shbz=='EUR'">
             {{ scope.row.purchasePriceEur }}
          </div>
          <div v-if="shbz=='USD'">
             {{ scope.row.purchasePriceUsd }}
          </div>
        
        </template>
      </el-table-column>
     
    </el-table>    
<div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next" :total="totale">
      </el-pagination>

    </div>





  

  </div>
</template>

<script>

import {  pageQueryPart,listMcSeriesModels,postOfDealer } from "../../api/api";
import Utils  from "../../utils/uilt.js";
export default {
  data () {
    return {
   
    
    
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      value:'',
      inle: 'zh',
      shbz:'',
 
    
      list: [ ],
   
      mation: [], //列表
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
    multipleSelection:[],
   
      num: [],
    };
  },
  created () {
    this.biao();
    this.listMcSeriesModel()
    this.shbz=sessionStorage.getItem('shbz')
    let a = sessionStorage.getItem('i18n')
    this.inle = a

  },
  filters: {
    cbjq: function (e) {
      let a =''
      let b =''
      // console.log(e);
      if(e!==null){
        a = e.split('/')
    
        b=a[a.length-1]
        
      }
      return b
  }
},
  
  methods: {
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.list = res.data;
      // this.formInline.mcSeriesModelId = this.mcSeriesModelId/

    },
    
   handleSelectionChange(val) {
    console.log(val);
    
        this.multipleSelection = val;
      },
    notType(e){
      let a =''
      this.titleList.forEach((z=>{
        if(e==z.dictValue){
          a=z.dictLabel
        }
      }))
      return a
    },
    async xinzeng(e){
        // let param = new URLSearchParams();
        
          let param={
            accTypeIdLs:sessionStorage.getItem('accTypeIdLs'),
            categoryId:e.categoryId,
            // dealerId:'1',
            mcSeriesModelId:e.mcSeriesModel!==null?e.mcSeriesModel.id:'',
            partCode:e.partNumber,
            partId:e.id,
            partName:e.partName,
            partName2:e.partNameEn,
            purchasePrice:e.purchasePriceCny,
            partCode:e.partNumber,
            currentStock:e.unit
          }
         
        const { data: res } = await postOfDealer(param);
            if(res.data.code==200){
               this.$message({
                 message: this.$t('menu.caozuochengong'),
                 type: 'success'
                 });
            }
        
    },
  xxaa(){
    console.log(this.multipleSelection);
    
       let b =this.multipleSelection
       b.forEach(e=>{
          this.xinzeng(e)
       })
       this.$router.push('/Accessories')
  },

    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let searchKey = this.formInline.title;

     let  mcSeriesModelId=this.value
      
       let categoryId=''
      const { data: res } = await pageQueryPart(
        param,
        this.currentPage3,
        10,
        mcSeriesModelId,
        searchKey,
        categoryId
      
      );

      this.mation = res.data.list;

      this.totale = res.data.total;
     
    },
   
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      // console.log(val);
      this.currentPage3=val
      this.biao();
    },
   
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;
  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.pop {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .btn1 {
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #409eff;
    }
  }

  .content {
    margin-bottom: 20px;
  }
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}
.cbjqq{
  margin-right: 10px;
  cursor: pointer;
  color: #409eff;
}
/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

.cctitle {
  color: #999999;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;

  p {
    cursor: pointer;
  }
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.row-title {
  font-size: 18px;
  color: #222222;
  font-weight: 550;
}

.content-box {
  position: relative;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 8px 4px;

  .qianshou {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>